import React from 'react';
import { useLanguageSelectListQuery } from 'api';
import { Select, SelectProps } from 'components';

export const LanguageSelect: React.FC<SelectProps & { setLabelAsValue?: boolean }> = React.memo((props) => {
  const { data = [] } = useLanguageSelectListQuery();
  const { setLabelAsValue, ...restProps } = props;

  return (
    <Select
      options={setLabelAsValue ? data.map((i: Record<string, any>) => ({ ...i, value: i.label || '' })) : data}
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      {...restProps}
    />
  );
});
